const GET_USERS = 'GET_USERS'
const SET_USERS = 'SET_USERS'
const GET_USER_BRANCHES = 'GET_USER_BRANCHES'
const SET_USER_BRANCHES = 'SET_USER_BRANCHES'
const SAVE_ASSET_INVENTORY_USER_BRANCHES = 'SAVE_ASSET_INVENTORY_USER_BRANCHES'
const SAVE_USER_BRANCH_SUCCESS = 'SAVE_USER_BRANCH_SUCCESS'
const GET_USER_EQUIPEMENT_ORDERER_ROLE = 'GET_USER_EQUIPEMENT_ORDERER_ROLE'
const GET_USERS_BY_EMP_ID = 'GET_USERS_BY_EMP_ID'

const SAVE_USER_PROFILE_PERSONAL_INFO = "SAVE_USER_PROFILE_PERSONAL_INFO"
const SAVE_USER_PROFILE_BRANCHES = "SAVE_USER_PROFILE_BRANCHES"
const SAVE_USER_PROFILE_NOTIFICATION_SUBSCRIPTION = "SAVE_USER_PROFILE_NOTIFICATION_SUBSCRIPTION"

const UPLOAD_USER_PROFILE_IMAGE = "UPLOAD_USER_PROFILE_IMAGE"
const SET_USER_PROFILE_IMAGE = "SET_USER_PROFILE_IMAGE"

export {
    GET_USERS,
    SET_USERS,
    GET_USER_BRANCHES,
    SET_USER_BRANCHES,
    SAVE_ASSET_INVENTORY_USER_BRANCHES,
    SAVE_USER_BRANCH_SUCCESS,
    GET_USER_EQUIPEMENT_ORDERER_ROLE,
    GET_USERS_BY_EMP_ID,
    SAVE_USER_PROFILE_PERSONAL_INFO,
    SAVE_USER_PROFILE_BRANCHES,
    SAVE_USER_PROFILE_NOTIFICATION_SUBSCRIPTION,
    UPLOAD_USER_PROFILE_IMAGE,
    SET_USER_PROFILE_IMAGE
}